import { FETCH_LOGINLOGS_LIST, FETCH_DOWNLOADLOGINLOGS_LIST } from "../actions/loginLogsAction";
import { isFulfilled, isPending, isRejected } from "./reducerUtils";

const initalState = {
    loginlogsList: [],
    pages: 0,
    paginationFetch: false,
    loginlogsListLoading: false,
    loginlogsListError: null,
};

const blocksourceReducer = (state = initalState, action) => {
    switch (action.type) {
        case isFulfilled(FETCH_LOGINLOGS_LIST): {
            let loginlogsList;
            if (action.payload.pagination) {
                loginlogsList = [...state.loginlogsList, ...action.payload.data];
            } else loginlogsList = action.payload.data;
            return {
                ...state,
                loginlogsList,
                pages: action.payload.total_records,
                paginationFetch: action.payload.pagination,
                loginlogsListLoading: false,
                loginlogsListError: null,
            };
        }
        case isPending(FETCH_LOGINLOGS_LIST):
            return { ...state, loginlogsListLoading: true, loginlogsListError: null };
        case isRejected(FETCH_LOGINLOGS_LIST):
            return {
                ...state,
                loginlogsList: null,
                loginlogsListLoading: false,
                loginlogsListError: action.payload,
            };
        default:
            return state;
    }
};

export default blocksourceReducer;
